import { CheckmarkCircleIcon, CloseIcon, InfoSquareIcon, WarningIcon } from "@/domains/icons"

export type ToastTypes = "info" | "success" | "error"

export type Toast = {
  title: string
  description: string
  footer?: string
  toastType: ToastTypes
  errorCode?: string
  // transaction?: string
}

const toastTypeToIconMap: Record<ToastTypes, React.ReactNode> = {
  info: <InfoSquareIcon className="h-4 w-4 text-[#7B91FF]" />,
  success: <CheckmarkCircleIcon className="h-4 w-4 text-[#00B356]" />,
  error: <WarningIcon className="h-4 w-4 text-[#FF6C66]" />,
}

export const Toast = ({
  notification,
  t,
  toast,
}: {
  notification: Toast
  t: unknown
  toast: { dismiss: (t: unknown) => void }
}) => {
  const IconComponent = toastTypeToIconMap[notification.toastType]

  return (
    <div className="relative min-w-[320px] rounded-lg border border-p200-light bg-p200 p-0 md:max-w-[420px]">
      <div className="pointer-events-none absolute inset-0 rounded-lg bg-black/50" aria-hidden />
      <div className="relative z-10">
        <div
          className="absolute -right-[6px] -top-[6px] z-50 flex h-[20px] w-[20px] cursor-pointer items-center justify-center rounded-full border border-p200-light bg-black/25"
          onClick={() => {
            toast.dismiss(t)
          }}
        >
          <CloseIcon size={12} className="text-t100" />
        </div>
        <div className="flex flex-row items-center gap-2 p-4 text-sm font-medium text-t100 [&+div]:text-xs">
          {IconComponent}
          <p>{notification.title}</p>
        </div>
        <div data-orientation="horizontal" role="none" className="h-[1px] w-full shrink-0 bg-p200-light" />
        <div className="p-4 text-sm font-normal text-t200 opacity-90">
          <p>{notification.description}</p>
        </div>
        {notification.footer ? (
          <>
            <div data-orientation="horizontal" role="none" className="h-[1px] w-full shrink-0 bg-p200-light text-sm" />
            <div className="flex items-center justify-between p-4 text-sm text-t100">{notification.footer}</div>
          </>
        ) : null}
      </div>
    </div>
  )
}
